import { Box, Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import SingleInfoForm from './components/SingleInfoForm';

export default function StampSingleCreatePage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.create);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.addTreasure')}
					</Typography>
					<Card sx={{ marginTop: 3 }}>
						<SingleInfoForm type={type} setType={setType} />
					</Card>
				</Box>
			</Box>
		</>
	);
}
